
        var result = require("!!../../../../node_modules/css-loader/index.js!./subscription-plan-card.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/subscription/subscription-plan-card.component.css
// module id = 1501
// module chunks = 0